import React from 'react';
import MatchCard from '../components/MatchCard/MatchCard';

function Matches() {
  return (
    <div className="matches-page">
      <h1>Match Schedule</h1>
      <MatchCard title="Indosam CC vs Team B" date="April 15, 2025" venue="Away" />
      {/* Add more matches */}
    </div>
  );
}

export default Matches;